import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import type { PendingExitSlipFinish } from '../../businessLogicService/StudentDashboardAux/exitSlipOutcome';

export interface ExitSlipPendingFinishState {
  // The exit ticket this device has seen finished while the server has not reported it back yet, or
  // null once it has. Owned by DashboardExitSlipQuery, which holds the record and knows when it stops
  // being needed (see readPendingExitSlipFinish for why it is stored at all).
  //
  // Published here purely so a second reader can react to it: the unit-path cards' badges are built
  // by DashboardSkillExitSlipReportQuery from a report fetched once when the dashboard opened, and
  // that component has no way of hearing about a finish otherwise — localStorage does not notify, and
  // the two components are siblings under DashboardCards with no common parent below the page.
  value: PendingExitSlipFinish | null;
}

const initialState: ExitSlipPendingFinishState = { value: null };

export const exitSlipPendingFinishSlice = createSlice({
  name: 'exitSlipPendingFinish',
  initialState,
  reducers: {
    setExitSlipPendingFinish: (
      state: ExitSlipPendingFinishState,
      action: PayloadAction<PendingExitSlipFinish | null>,
    ) => {
      state.value = action.payload;
    },
  },
});

export const selectedExitSlipPendingFinish = (state: RootState) => state.exitSlipPendingFinish.value;

export const { setExitSlipPendingFinish } = exitSlipPendingFinishSlice.actions;

export default exitSlipPendingFinishSlice.reducer;
